import { render, staticRenderFns } from "./PerspectiveList.vue?vue&type=template&id=1f63a16a&"
import script from "./PerspectiveList.vue?vue&type=script&lang=js&"
export * from "./PerspectiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports